// Events
export const REFERENCE_DATA_SET_VALUE = 'raOptimal/referenceData/setValue/';
export const REFERENCE_DATA_GET_VALUE = 'raOptimal/referenceData/getValue/';

export const setReferenceData = value => ({ type: REFERENCE_DATA_SET_VALUE, value });
export const getReferenceData = () => ({ type: REFERENCE_DATA_GET_VALUE });
